(function () {
  if (window.__fwCartCountInitialized) return;
  window.__fwCartCountInitialized = true;

  /* Shared Liquid → JS localization bridge (snippets/fw-landing-i18n.liquid).
     The fallbacks are the English strings, so landing pages that do not render
     the bridge keep working unchanged. plural() picks the CLDR form for a count
     the browser knows; the server-rendered markup uses Shopify's own
     pluralization (sections.header.cart_count) and is already correct. */
  function i18nPlural(key, count, fallbackOne, fallbackOther) {
    if (window.FWI18n && typeof window.FWI18n.plural === 'function') {
      return window.FWI18n.plural(key, count, fallbackOne, fallbackOther);
    }
    var fallback = Number(count) === 1 ? fallbackOne : fallbackOther;
    return fallback.split('%count%').join(String(count));
  }

  async function fwUpdateCartCount() {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      const countEls = document.querySelectorAll('[data-fw-cart-count]');

      countEls.forEach((el) => {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
        el.setAttribute(
          'aria-label',
          i18nPlural('cart.item_count', cart.item_count, '%count% item', '%count% items')
        );
        const cartLink = el.closest('a[href*="/cart"]');
        if (cartLink) {
          cartLink.setAttribute(
            'aria-label',
            i18nPlural('cart.cart_with_count', cart.item_count, 'Cart (%count% item)', 'Cart (%count% items)')
          );
        }
        el.classList.toggle('is-empty', cart.item_count === 0);
        el.classList.toggle('hidden', cart.item_count === 0);
        el.classList.toggle('cart-count-bubble--dot', cart.item_count >= 100);
      });
    } catch (error) {
      console.warn('Cart count update failed:', error);
    }
  }

  window.fwUpdateCartCount = fwUpdateCartCount;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fwUpdateCartCount);
  } else {
    fwUpdateCartCount();
  }

  ['cart:updated', 'cart:update', 'cart:refresh', 'cart:build', 'cart-drawer:updated', 'theme:cart:update'].forEach((eventName) => {
    document.addEventListener(eventName, fwUpdateCartCount);
  });
})();
